/**
 * Filter items based on a search term and specified display property
 * @param items - Array of items to filter
 * @param searchTerm - The search term to filter by
 * @param displayProp - The property of the item to search against
 * @returns Filtered array of items matching the search term
 */
export function filterItemsBySearchTerm<T>(
  items: T[],
  searchTerm: string,
  displayProp: keyof T
): T[] {
  if (!items?.length) {
    return [];
  }

  const trimmedSearchTerm = searchTerm.trim().toLowerCase();

  if (!trimmedSearchTerm) {
    return items;
  }

  return items.filter((item) => {
    const displayValue = String(item[displayProp]).toLowerCase();
    return displayValue.includes(trimmedSearchTerm);
  });
}
